import { takeLatest, fork, put, all, call } from "redux-saga/effects"
import i18n from "i18n"
import { API } from "api"
import { staticPagesList } from "./slice"

export function* getList() {
  try {
    const response = yield call(API.admin.getStaticPages)

    const { data } = response

    yield put(staticPagesList.getListCompleted(data))
  } catch (error) {
    const message = error.response?.data?.message || i18n.t("error")
    yield put(staticPagesList.getListRejected(message))
  }
}

export function* watchGetList() {
  yield takeLatest(staticPagesList.getList, getList)
}

function* listSaga() {
  yield all([fork(watchGetList)])
}

export default listSaga
